/** Renvoie une fonction `(t) => boolean` qui laisse passer au plus `perSecond` appels par seconde. */
export function createThrottle(perSecond: number): (t: number) => boolean {
  if (!(perSecond > 0)) throw new Error('fréquence invalide');
  const interval = 1000 / perSecond;
  let next = -Infinity;
  return (t) => {
    if (t < next) return false;
    // Source régulière : cadence exacte, sans dérive. Après un trou : on repart
    // de maintenant (pas de rafale pour « rattraper » le retard).
    next = t - next > interval ? t + interval : next + interval;
    return true;
  };
}
